import React, { useEffect, useMemo } from 'react';
import { AppGrid } from 'src/components/App';
import { useDashboardStore } from '../../../utils/dashboardStore';
import { Typography } from '@mui/material';
import { useStyles } from './style';

function TeamGrid() {
  const classes = useStyles();
  const { fetchTeamStats, teamStats, loading, filters } = useDashboardStore();
  const { data, paging, sort } = teamStats;

  const columns = useMemo(
    () => [
      {
        name: 'name',
        label: 'Team Name',
        options: {
          sort: true,
          setCellHeaderProps: (value) => ({
            style: { width: 10 },
          }),
          setCellProps: () => ({
            style: { width: 10 },
          }),
          customBodyRenderLite: (dataIndex) => {
            const row = data[dataIndex];
            return (
              <Typography color="secondary" variant="body2">
                {row?.name || ''}
              </Typography>
            );
          },
        },
      },
      {
        name: 'enrolled',
        label: 'Enrolled',
        value: 'prospectsEnrolled',
        options: {
          sort: true,
          customBodyRenderLite: (dataIndex) => {
            const row = data[dataIndex];
            return row?.prospectsEnrolled;
          },
          setCellHeaderProps: () => ({ className: classes.centeredHeader }),
          setCellProps: () => ({ className: classes.centeredCell }),
        },
      },
      {
        name: 'contacted',
        label: 'Contacted',
        options: {
          sort: true,
          customBodyRenderLite: (dataIndex) => {
            const row = data[dataIndex];
            return row?.prospectsContacted;
          },
          setCellHeaderProps: () => ({ className: classes.centeredHeader }),
          setCellProps: () => ({ className: classes.centeredCell }),
        },
      },
      {
        name: 'opened',
        label: 'Opened',
        options: {
          sort: true,
          customBodyRenderLite: (dataIndex) => {
            const row = data[dataIndex];
            return row?.prospectsOpened;
          },
          setCellHeaderProps: () => ({ className: classes.centeredHeader }),
          setCellProps: () => ({ className: classes.centeredCell }),
        },
      },
      {
        name: 'clicked',
        label: 'Clicked',
        options: {
          sort: true,
          customBodyRenderLite: (dataIndex) => {
            const row = data[dataIndex];
            return row?.prospectsClicked;
          },
          setCellHeaderProps: () => ({ className: classes.centeredHeader }),
          setCellProps: () => ({ className: classes.centeredCell }),
        },
      },
      {
        name: 'replied',
        label: 'Replied',
        options: {
          sort: true,
          customBodyRenderLite: (dataIndex) => {
            const row = data[dataIndex];
            return row?.prospectsReplied;
          },
          setCellHeaderProps: () => ({ className: classes.centeredHeader }),
          setCellProps: () => ({ className: classes.centeredCell }),
        },
      },
      {
        name: 'interested',
        label: 'Interested',
        options: {
          sort: true,
          customBodyRenderLite: (dataIndex) => {
            const row = data[dataIndex];
            return row?.prospectsInterested;
          },
          setCellHeaderProps: () => ({ className: classes.centeredHeader }),
          setCellProps: () => ({ className: classes.centeredCell }),
        },
      },
    ],
    [data],
  );

  useEffect(() => {
    fetchTeamStats({ perPage: paging?.perPage, pageNo: 0 }, filters);
  }, [filters]);

  const handleTableChange = async ({ pageNo, perPage }) => {
    try {
      fetchTeamStats({
        pageNo,
        perPage,
      });
    } catch (error) {
      console.error('Error: ', error);
    }
  };

  const onSort = (sort) => {
    fetchTeamStats(paging, sort);
  };

  return (
    <AppGrid
      columns={columns.map((col, index) => ({
        ...col,
        options: columns?.columns?.length
          ? { ...col.options, ...columns?.columns[index] }
          : col.options,
      }))}
      onSort={onSort}
      onTableChange={handleTableChange}
      data={data}
      loading={loading.teamStats}
      options={{
        sortOrder: sort,
        serverSide: true,
        pagination: true,
        page: paging.pageNo,
        rowsPerPage: paging.perPage,
        count: paging.count,
      }}
    />
  );
}

export default TeamGrid;
